import { useState } from 'react'
import { Link, useNavigate } from '@tanstack/react-router'
import { useAuth } from '../../contexts/AuthContext'

export function Navigation() {
  const [isOpen, setIsOpen] = useState(false)
  const { isAuthenticated, logout } = useAuth()
  const navigate = useNavigate()

  const toggleMenu = () => setIsOpen(!isOpen)
  const closeMenu = () => setIsOpen(false)

  const handleLogout = async () => {
    await logout()
    closeMenu()
    navigate({ to: '/' })
  }

  return (
    <nav className="bg-primary text-accent w-full">
      <div className="w-full max-w-none px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 w-full">
          {/* Brand */}
          <Link 
            to={isAuthenticated ? '/dashboard' : '/'} 
            className="text-2xl font-bold hover:opacity-80 transition-opacity"
            onClick={closeMenu}
          >
            zkejul
          </Link>

          {/* Desktop Navigation */}
          {!isAuthenticated ? (
            <div className="hidden md:flex items-center gap-6">
              <Link 
                to="/login"
                className="hover:opacity-80 transition-opacity font-medium"
              >
                Login
              </Link>
              <Link 
                to="/register"
                className="btn btn-accent btn-sm"
              >
                Register
              </Link>
            </div>
          ) : (
            <div className="hidden md:flex items-center gap-6">
              <Link 
                to="/dashboard"
                className="hover:opacity-80 transition-opacity font-medium"
              >
                Dashboard
              </Link>
              <button 
                onClick={handleLogout}
                className="btn btn-accent btn-sm"
              >
                Logout
              </button>
            </div>
          )}

          {/* Mobile Hamburger Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden btn btn-ghost btn-square"
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      <div
        className={`md:hidden fixed inset-0 z-50 transition-opacity duration-300 ${
          isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        {/* Backdrop */}
        <div
          className="absolute inset-0 bg-black/50"
          onClick={closeMenu}
        />

        {/* Drawer */}
        <div
          className={`absolute right-0 top-0 h-full w-64 bg-primary shadow-xl transform transition-transform duration-300 ${
            isOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <div className="flex flex-col h-full">
            {/* Close Button */}
            <div className="flex justify-end p-4">
              <button
                onClick={closeMenu}
                className="btn btn-ghost btn-square"
                aria-label="Close menu"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Menu Items */}
            <div className="flex flex-col gap-4 px-6 py-4">
              {!isAuthenticated ? (
                <>
                  <Link
                    to="/login"
                    className="text-lg font-medium hover:opacity-80 transition-opacity py-2"
                    onClick={closeMenu}
                  >
                    Login
                  </Link>
                  <Link
                    to="/register"
                    className="btn btn-accent"
                    onClick={closeMenu}
                  >
                    Register
                  </Link>
                </>
              ) : (
                <>
                  <Link
                    to="/dashboard"
                    className="text-lg font-medium hover:opacity-80 transition-opacity py-2"
                    onClick={closeMenu}
                  >
                    Dashboard
                  </Link>
                  <button
                    className="btn btn-accent"
                    onClick={handleLogout}
                  >
                    Logout
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}
